import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class SaleService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination, transforms }) {
    const url = `/v1/companies/${companyUuid}/sales`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      transforms
    });
    return await this.get(resourceRoute);
  }

  async getDocument(companyUuid, uuid) {
    const url = `/v1/companies/${companyUuid}/sales/${uuid}/document`;
    return await this.get(url, { responseType: "arraybuffer" });
  }

  async cancelNfce(sale_uuid) {
    return await this.post("/v1/sales/cancel", { sale_uuid });
  }

  async update(companyUuid, uuid, params) {
    return await super.update(
      `/v1/companies/${companyUuid}/sales/${uuid}`,
      params
    );
  }

  async fetchByUuid(companyUuid, uuid) {
    return await this.get(`/v1/companies/${companyUuid}/sales/${uuid}`);
  }

  async report(params) {
    return await this.get(`/proxy/stitch_app/sales_report_by_hour`, params);
  }
}

export default SaleService;



// WEBPACK FOOTER //
// ./src/core/service/sale.service.js